import * as React from 'react'
import FormControl from "@material-ui/core/FormControl";
import {MyInput, Label, PrimaryButton, WhiteButton} from "../../components/CustomUIComp/CustomFormElem";
import InputAdornment from "@material-ui/core/InputAdornment";
import './RateMarkUpModal.scss'
import {injectIntl, IntlShape} from 'react-intl'
import FormHelperText from "@material-ui/core/FormHelperText";

interface IProps {
    handleMarkUpRateChange: (event: any) => void,
    markupRate: string,
    onClose: () => void,
    onConfirm: () => void,
    intl: IntlShape,
    error: string
}
interface IState {

}

class RateMarkUpModal extends React.Component<IProps, IState> {
    public render() {
        let {intl} = this.props
        return <div className="rateMarkupModal">
            <FormControl className="formControl" fullWidth required error={this.props.error ? true: false}>
                <Label shrink htmlFor="bootstrap-input">
                    {intl.formatMessage({id: 'modifyRate'})}
                </Label>
                <MyInput value={this.props.markupRate}
                        onChange={this.props.handleMarkUpRateChange}
                        name="rate"
                        endAdornment={<InputAdornment position="end">%</InputAdornment>}
                        />
                {this.props.error ?
                    <FormHelperText id="component-error-text">{this.props.error}</FormHelperText> : null}
            </FormControl>
            <div className="button-line">
                <WhiteButton onClick={this.props.onClose}>
                    {intl.formatMessage({id: 'cancel'})}
                </WhiteButton>
                <PrimaryButton onClick={this.props.onConfirm}>
                    {intl.formatMessage({id: 'confirm'})}
                </PrimaryButton>
            </div>
        </div>;
    }
}

export default injectIntl(RateMarkUpModal)
